export const COMPANY_PROFILE = {
  legalName: 'Swarvinn Impex Ltd',
  tagline: 'Global Trade. Trusted Quality.',
  founded: 'Tamil Nadu, India',
  headquarters: 'Tamil Nadu, India',
  exportMarket: 'United Kingdom',
  primaryMarket: 'United Kingdom',
  secondaryMarkets: [
    'Europe',
    'UAE & Middle East',
    'USA',
    'Canada',
    'Australia',
    'Singapore',
  ],
  businessType: 'Import & Export — Indian Grocery & Food Products',
  email: 'export@swarvinnimpex.com',
  phone: '+91 442 234 5678',
  moq: '50 kg per product (wholesale)',
  packing: '50g retail packs to bulk sacks',
};

export const COMPANY_OVERVIEW = [
  'Swarvinn Impex Ltd is a Tamil Nadu-based export house specialising in authentic Indian grocery and food products. Our main export country is the United Kingdom, where we supply wholesalers, cash & carry operators, Asian supermarkets, restaurant suppliers, and independent food retailers.',
  'From premium rice and whole spices to pulses, millets, flours, cold-pressed oils, pickles, and traditional snacks — we supply export-grade products with consistent quality, competitive trade pricing, and dependable logistics. Secondary markets include Europe, the UAE & Middle East, USA, Canada, Australia, and Singapore.',
  'Our team handles sourcing, quality grading, vacuum packing, private-label re-labelling, export documentation, and freight coordination so your business can focus on serving customers — with UK delivery as our primary route and other countries supported on request.',
];

export const MISSION_VISION = [
  {
    title: 'Our Mission',
    text: 'To deliver authentic Indian food products with uncompromising quality and transparent export processes — prioritising the United Kingdom while supporting selected secondary markets.',
  },
  {
    title: 'Our Vision',
    text: 'To become a trusted name for Indian grocery import into the UK — known for quality sourcing, destination-ready packaging, and seamless India-to-market delivery.',
  },
];

export const COMPANY_DETAILS = [
  { label: 'Company Name', value: 'Swarvinn Impex Ltd' },
  { label: 'Business Activity', value: 'Export of Indian rice, spices, pulses, flours, oils & grocery products' },
  { label: 'Registered Office', value: 'Tamil Nadu, India' },
  { label: 'Main Export Country', value: 'United Kingdom' },
  { label: 'Secondary Markets', value: 'Europe, UAE & Middle East, USA, Canada, Australia, Singapore' },
  { label: 'Target Customers', value: 'Wholesalers, cash & carry, supermarkets, distributors & retailers' },
  { label: 'Product Categories', value: 'Rice, Spices, Grains & Pulses, Oils, Specialty Items' },
  { label: 'Minimum Order', value: '50 kg per product (wholesale)' },
  { label: 'Packing Options', value: '50g to bulk — vacuum packed & private label available' },
  { label: 'Freight Routes', value: 'Sea freight to UK ports first; other countries on request' },
  { label: 'Contact Email', value: 'export@swarvinnimpex.com' },
  { label: 'Contact Phone', value: '+91 442 234 5678' },
];

export const CORE_VALUES = [
  {
    icon: 'shield',
    title: 'Export-Grade Quality',
    desc: 'FSSAI certified sourcing, batch inspection, and grading before every shipment leaves India.',
  },
  {
    icon: 'globe',
    title: 'UK Main Market',
    desc: 'Products, packing, and documentation prepared first for British wholesale and retail trade, with secondary markets supported as needed.',
  },
  {
    icon: 'handshake',
    title: 'Long-Term Partnerships',
    desc: 'We work as your India-side supply partner — not a one-off vendor — with repeat orders and custom requirements.',
  },
  {
    icon: 'package',
    title: 'Flexible Supply',
    desc: 'Private label, re-labelling, mixed containers, and custom assortments for your destination market.',
  },
];

export const CERTIFICATIONS = [
  'FSSAI certified products and processing partners',
  'Export-grade quality inspection on every batch',
  'HS / HMRC commodity codes on all shipments',
  'Certificates of origin & phytosanitary documentation',
  'UK-ready labelling and private-label support',
];

export const ABOUT_PAGE_IMAGES = {
  hero: '/images/about-main.png',
  inset: '/images/about-inset.png',
  gallery: [
    '/images/about-main.png',
    '/images/about-inset.png',
    '/images/hero-spices.png',
  ],
};
